import { Component, Input } from '@angular/core';
import { Breakpoints } from '../../classes/breakpoints.class';

@Component({
  selector: 'app-two-column-search-layout',
  templateUrl: './two-column-search-layout.component.html',
  styleUrls: ['./two-column-search-layout.component.scss'],
})
export class TwoColumnSearchLayoutComponent {
  @Input() public isLoading: boolean = true;
  @Input() public hasResults: boolean = false;
  @Input() public showInformationPane: boolean = true;
  @Input() public informationIsSticky: boolean = true;
  @Input() public showFilterPane: boolean = false;
  @Input() public reverseColumns: boolean = false;
  @Input() public stickyInfo: boolean = true;

  constructor(public breakpoints: Breakpoints) {}
}
